import { useCallback, useState } from 'react';

export type QuestionSaveOp = 'debounceStarting'|'idle'|'saving'|'saved'|'focused';

type QuestionSaveStatus = {
  op: QuestionSaveOp,
  questionId: number,
  caseId?: number,
}

const useQuestionSaveStatus = (questionId: number, caseId?: number) => {
  const [saveOp, setSaveOp] = useState<QuestionSaveStatus>({
    op: 'idle',
    questionId,
    caseId,
  });

  const setSaveOperation = useCallback((op: QuestionSaveOp) => {
    setSaveOp({
      op,
      questionId,
      caseId,
    });
  }, [caseId, questionId]);

  return [saveOp, setSaveOperation] as const;
};

export default useQuestionSaveStatus;
